import { React } from 'react';
import {Row, Col, Container} from 'react-bootstrap';
import "./subnavbar.css";
  
function SubNavBar(props){

    console.log(props)

    return(
        <Container fluid id="sub-nav-container">
            <Row id="sub-nav-row" className="justify-content-md-center">
                <Col id="sub-nav-content" md="auto">
                    {props.values.map(value => (
                        <p className="sub-nav-item"><b>{value.heading}: </b>{value.text}</p>
                    ))}
                </Col>
            </Row>
        </Container>
    );
}

export default SubNavBar;